import cx from 'clsx';
import React from 'react';

import type { IHardwareOverviewEquipmentInfo } from '../../model/hardwareOverviewItem';
import style from './style.module.scss';

interface IProps {
  info: IHardwareOverviewEquipmentInfo;
}

const Ratio: React.FC<IProps> = ({ info }) => {
  const criticalPercentPart = (info.countAiItemsUrgencyCritical / info.countItems) * 100;
  const highPercentPart = (info.countAiItemsUrgencyHigh / info.countItems) * 100;
  const standardPercentPart = (info.countAiItemsUrgencyStandard / info.countItems) * 100;

  const allAiPercentPart = criticalPercentPart + highPercentPart + standardPercentPart;

  return (
    <div className={style.ratioBlock}>
      {info.countItems === 0 ? (
        <div className={cx(style.ratioBlockPart, style.noItems)} />
      ) : (
        <>
          {!!criticalPercentPart && (
            <div
              className={cx(style.ratioBlockPart, style.critical)}
              style={{ width: `${criticalPercentPart}%` }}
            />
          )}
          {!!highPercentPart && (
            <div className={cx(style.ratioBlockPart, style.high)} style={{ width: `${highPercentPart}%` }} />
          )}
          {!!standardPercentPart && (
            <div
              className={cx(style.ratioBlockPart, style.standard)}
              style={{ width: `${standardPercentPart}%` }}
            />
          )}
          <div
            className={cx(style.ratioBlockPart, style.noAi)}
            style={{ width: `${100 - allAiPercentPart}%` }}
          />
        </>
      )}
    </div>
  );
};

export default Ratio;
